<nav class="navbar navbar-expand-lg nav_style">
  <div class="container-fluid" style="height: 4rem;">
    <div class="col-md-3 image_container_style">
      <img src="../../../assets/images/LOGO_FIGURINO.png">
    </div>
    <div class="col-md-6 d-flex header_element px-4" *ngIf="!isSpecificRoute()">
      <div *ngIf="isSpecificRole('pim')" routerLink="/pim" style="align-self: center" [routerLink]="['/pim']" [routerLinkActive]="'active'">
        <button class="btn button_style_header" (click)="resetLocalStorage('pim')">
          <i class="fas fa-th-large a_header_element"></i>PIM
        </button>
      </div>
      <div *ngIf="isSpecificRole('dam')" routerLink="/dam" style="align-self: center" [routerLink]="['/dam']" [routerLinkActive]="'active'">
        <button class="btn button_style_header" (click)="resetLocalStorage('dam')">
          <i class="fas fa-camera a_header_element"></i>DAM
        </button>
      </div>
      <div *ngIf="isSpecificRole('dictionary')" routerLink="/crud-table" style="align-self: center" [routerLink]="['/crud-table']" [routerLinkActive]="'active'">
        <button class="btn button_style_header" (click)="resetLocalStorage('crud-table')">
          <i class="fas fa-archive a_header_element"></i>
          {{ 'DictionaryU' | translate }}
        </button>
      </div>
      <div *ngIf="isSpecificRole('catalogs')" routerLink="/catalogues" style="align-self: center" [routerLink]="['/catalogues']" [routerLinkActive]="'active'">
        <button class="btn button_style_header" (click)="resetLocalStorage('catalogues')"><i class="fas fa-th a_header_element"></i>
          {{ 'CatalogsU' | translate }}
        </button>
      </div>
      <div *ngIf="isSpecificRole('users')" routerLink="/users" style="align-self: center" [routerLink]="['/users']" [routerLinkActive]="'active'">
        <button class="btn button_style_header" (click)="resetLocalStorage('users')"><i class="fas fa-users a_header_element"></i>
          {{ 'UsersU' | translate }}
        </button>
      </div>
    </div>
    <div class="col-md-3 d-flex justify-content-end pe-4" style="align-items: center;">
      <div class="px-2">
        <button class="btn btn_flags flex-column px-0"  style="background-color: white;"
        [ngClass]="{ 'btn_flags_style_open': isCountryDropdownOpen }"
          aria-haspopup="true" >
          <div class="d-flex align-items-center" style="height: 2.5rem; width: 100%;" (click)="openCountryButton()">
            <img [src]="selectedCountry ? selectedCountry.icon : ''">
            <i *ngIf="!isCountryDropdownOpen" class="fas fa-chevron-down"></i>
            <i *ngIf="isCountryDropdownOpen" class="fas fa-chevron-up"></i>
          </div>
          <div *ngIf="isCountryDropdownOpen" style="width: 100%;">
            <a *ngFor="let country of listCountry" (click)="selectCountry(country)" >
              <div class="btn_flags_dropdown" *ngIf="selectedCountry !== country">
                <img [src]="country.icon" class="bandiera-lingua" alt="Bandiera">
                <b>{{ country.name }}</b>
              </div>
            </a>
          </div>
        </button>
      </div>
      <div *ngIf="!isSpecificRoute()" class="user_icon d-flex justify-content-center align-items-center">
        <label>{{getInitials()}}</label>
      </div>
      <div class="button_container_style" *ngIf="!isSpecificRoute()">
        <button class="btn btn_logout" (click)="onLogoutButton()">
          {{ 'Logout' | translate }}
        </button>
      </div>
    </div>
  </div>
</nav>

<div>
  <app-logout-modal></app-logout-modal>
</div>